(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nina-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateHeader = () => document.body.classList.toggle('nina-header-scrolled', window.scrollY > 36);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.nina-reveal').forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.nina-reveal').forEach((element) => observer.observe(element));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nina-editorial-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nina-scroll]');
    if (!button) return;
    const section = button.closest('[data-nina-product-section]');
    const track = section?.querySelector('[data-nina-product-track]');
    if (!track) return;
    const direction = button.dataset.ninaScroll === 'previous' ? -1 : 1;
    track.scrollBy({ left: track.clientWidth * 0.86 * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
